import React, { useEffect, useState } from "react";

import { useIsClientSide } from "@utils/hooks/isClient.hook";

import { TProductDetailState } from "@redux/modules/value/productDetail/productDetail.types";

import OrderButton from "./orderButton.component";

type Props = {
    productDetail: TProductDetailState;
    onSubmit: () => void;
    isSoldOut: boolean;
    isEcommerceReady: boolean;
    hasMontageParents: boolean;
    isConfigurationValid?: boolean;
    size?: "md" | "sm" | "lg";
};

const OrderButtonContainer = ({
    productDetail,
    onSubmit,
    isSoldOut,
    isEcommerceReady,
    hasMontageParents,
    isConfigurationValid = true,
    size = "md",
}: Props) => {
    const [isDisabled, setIsDisabled] = useState(true);
    const isClientSide = useIsClientSide();

    useEffect(() => {
        setIsDisabled(
            !canSubmit() ||
                !isEcommerceReady ||
                !isConfigurationValid ||
                isSoldOut ||
                hasMontageParents,
        );
    }, [isSoldOut, isEcommerceReady, isConfigurationValid, productDetail]);

    useEffect(() => {
        if (!isDisabled) {
            try {
                performance.mark("Hubo: Ecommerce is enabled");
                performance.measure(
                    "Hubo: Ecommerce is enabled",
                    "Hubo: Hydrator.ssr.ECOMMERCE",
                );
            } catch (e) {
                console.log("unable to measure: Ecommerce is enabled");
            }
        }
    }, [isDisabled]);

    const canSubmit = () => {
        return productDetail.sku !== "" && productDetail.quantity > 0;
    };

    if (!isClientSide) {
        return <></>;
    }

    return (
        <OrderButton isDisabled={isDisabled} onSubmit={onSubmit} size={size} />
    );
};

export default OrderButtonContainer;
